import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';

const ConfirmDialog = ({
  children,
  containerStyle,
  childContainerStyle,
  manageHandleOpen,
  manageHandleClose,
  title,
  actions,
  content,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div css={{ ...containerStyle }}>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick
        disableEscapeKeyDown
      >
        {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
        {content && <DialogContent>{content()}</DialogContent>}
        {actions && <DialogActions>{actions({ handleClose })}</DialogActions>}
        {manageHandleClose && (
          <Button
            color="primary"
            variant="contained"
            onClick={handleClose}
            style={{ marginTop: '15px' }}
          >
            Close
          </Button>
        )}
      </Dialog>
      <div
        css={{ ...childContainerStyle }}
        onClick={e => {
          manageHandleOpen && handleOpen(e);
        }}
      >
        {children({ handleOpen })}
      </div>
    </div>
  );
};

export default ConfirmDialog;
